// import addLegislation from '../components/notice/addLegislation.vue'
// import addNotice from '../components/notice/addNotice.vue'
// import editLegislation from '../components/notice/editLegislation.vue'
// import editNotice from '../components/notice/editNotice.vue'
// import legislationList from '../components/notice/legislationList.vue'
// import noticeList from '../components/notice/noticeList.vue'
// import viewNotice from '../components/notice/viewNotice.vue'
// import addAudio from '../components/notice/addAudio.vue'
// import addImgText from '../components/notice/addImgText.vue'
// import addVideo from '../components/notice/addVideo.vue'
// import addWord from '../components/notice/addWord.vue'
// import trainList from '../components/notice/trainList.vue'
// import viewTrain from '../components/notice/viewTrain.vue'

export default [
    {
        path: 'notice/addLegislation',
        component: resolve => require(['@/components/notice/addLegislation'],resolve),
        name:"AddLegislation",
        meta:{
            id:'673',
            node:'notice',
            url:'addLegislation',
        }
    },
    {
        path: 'notice/addNotice',
        component: resolve => require(['@/components/notice/addNotice'],resolve),
        name:"AddNotice",
        meta:{
            id:'669',
            node:'notice',
            url:'addNotice',
        }
    },
    {
        path: 'notice/editLegislation',
        component: resolve => require(['@/components/notice/editLegislation'],resolve),
        name:"EditLegislation",
        meta:{
            id:'674',
            node:'notice',
            url:'editLegislation',
        }
    },
    {
        path: 'notice/editNotice',
        component: resolve => require(['@/components/notice/editNotice'],resolve),
        name:"EditNotice",
        meta:{
            id:'670',
            node:'notice',
            url:'editNotice',
        }
    },
    {
        path: 'notice/legislationList',
        component: resolve => require(['@/components/notice/legislationList'],resolve),
        name:"LegislationList",
        meta:{
            id:'672',
            node:'notice',
            url:'legislationList',
        }
    },
    {
        path: 'notice/noticeList',
        component: resolve => require(['@/components/notice/noticeList'],resolve),
        name:"NoticeList",
        meta:{
            id:'667',
            node:'notice',
            url:'noticeList',
        }
    },
    {
        path: 'notice/viewNotice',
        component: resolve => require(['@/components/notice/viewNotice'],resolve),
        name:"ViewNotice",
        meta:{
            // id:'670',
            node:'notice',
            url:'viewNotice',
        }
    },
    {
        path: 'notice/addAudio',
        component: resolve => require(['@/components/notice/addAudio'],resolve),
        name:"AddAudio",
        meta:{
            id:'782',
            node:'notice',
            url:'AddAudio',
        }
    },
    {
        path: 'notice/addImgText',
        component: resolve => require(['@/components/notice/addImgText'],resolve),
        name:"AddImgText",
        meta:{
            id:'783',
            node:'notice',
            url:'addImgText',
        }
    },
    {
        path: 'notice/addVideo',
        component: resolve => require(['@/components/notice/addVideo'],resolve),
        name:"AddVideo",
        meta:{
            id:'784',
            node:'notice',
            url:'addVideo',
        }
    },
    {
        path: 'notice/addWord',
        component: resolve => require(['@/components/notice/addWord'],resolve),
        name:"AddWord",
        meta:{
            id:'785',
            node:'notice',
            url:'addWord',
        }
    },
    {
        path: 'notice/trainList',
        component: resolve => require(['@/components/notice/trainList'],resolve),
        name:"TrainList",
        meta:{
            id:'781',
            node:'notice',
            url:'trainList',
        }
    },
    {
        path: 'notice/viewTrain',
        component: resolve => require(['@/components/notice/viewTrain'],resolve),
        name:"ViewTrain",
        meta:{
            // id:'781',
            node:'notice',
            url:'viewTrain',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/notice.js